import * as v from "valibot";
import { rpcContract } from "../rpc";

export const sendCreatorMessageRpcContract = rpcContract({
  name: "send-creator-message",
  paramsSchema: v.object({
    messageId: v.string(),
  }),
  resultSchema: v.object({
    recipientCount: v.number(),
  }),
});

export type SendCreatorMessageParams = v.InferOutput<(typeof sendCreatorMessageRpcContract)["paramsSchema"]>;
export type SendCreatorMessageResult = v.InferOutput<(typeof sendCreatorMessageRpcContract)["resultSchema"]>;
